import React from 'react'
import resolveProps from '../../../utils/resolveProps'
import { ContainerProps } from './types'

const config = {
  types: [],
  modifiers: [],
  states: []
}


export default function Container(props: ContainerProps) {
  const { children, fluid, className = '', ...rest } = props
  const ComponentName = fluid ? 'Container-fluid' : 'Container'
  return (
    <div {...rest} className={`${resolveProps(props, config, ComponentName)}`}>
      {children}
    </div>
  )
}
